import { EManagementType, IHotlineAvailability } from './common.model';

export interface IAppState {
  hotlineAvailability: null | IHotlineAvailability;
  hideFinancialValues: boolean;
  collaboratorInfo: ICollaboratorDisplayed | null;
  collaboratorPhoto: string | null;
  unreadItemsSumCount: number;
  unreadNotificationsCount: number;
  unreadMessagesCount: number;
  // todo: remove when notification detail endpoint created
  selectedNotification: INotification | null;
  viewNeedUpdateOverlay: boolean,
}

export interface IHotlineAvailabilityResult {
  open: boolean;
  translateKey: string;
  time: string;
}

export interface ICollaboratorDisplayed {
  name: string,
  surname: string,
  phone: string,
  email: string,
}

export interface INativeBottomNavbarItem {
  label: string;
  icon: string;
  type: ENativeBottomNavbarItem;
  route: string;
}

export enum ENativeBottomNavbarItem {
  SUMMARY = 1, INVESTMENTS, MONEY, MY_CONSULTANT, MY_ACCOUNT
}

export interface IMessageAndNotificationItem {
  id: string;
  title: string;
  dateLabel: string;
}

export interface INotificationCount {
  totalSum: number,
  messageSum: number,
  noticeSum: number,
}

export interface INotificationResponse {
  totalCount: number,
  content: INotification[],
}

export interface INotification {
  notificationWebId: number,
  notificationTypeCode: 'ADDED_DEPOSIT',
  notificationWebStatus: ENotificationsStatus,
  createdDate: string, // ex. 2023-04-13T03:36:20.499Z
  notificationKind: ENotificationKind,
  htmlMessage: string,
  subject: string,
}

export enum ENotificationKind {
  MESSAGE = 'MESSAGE',
  NOTICE = 'NOTICE'
}

export enum ERegularWithdrawalType {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
}

export enum ENotificationsStatus {
  NEW = 'NEW',
  PROCESSED = 'PROCESSED',
  RESOLVED = 'RESOLVED',
  ERROR = 'ERROR',
}

export enum ENotificationTypeCode {
  ADDED_DEPOSIT = 'ADDED_DEPOSIT',
}

export interface IPushNotificationsRequestInput {
  deviceToken: string,
  platform: EApiDevicePlatforms,
}

export enum EApiDevicePlatforms {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export enum ECapacitorPlatforms {
  ANDROID = 'android',
  IOS = 'ios',
}

export interface IApiPushNotification {
  notificationWebId: number,
  portfolioId?: number,
  blogId?: number,
  from: number, // Firebase project ID
  type: EPushNotificationEventTypes,
  currency?: string,
  portfolioName?: string,
  portfolioTransactionId?: number,
  amount?: number,
  portfolioManagementType?: EManagementType,
  collapse_key?: string // If multiple notifications with the same collapse_key are received, only the most recent one will be shown to the user
  google?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any; // undocumented object wildcard
    original_priority: 'normal' | 'high',
    delivered_priority: 'normal' | 'high',
  }
}

export enum EPushNotificationEventTypes {
  ADDED_DEPOSIT = 'ADDED_DEPOSIT',
  ADDED_DEPOSIT_LESS_THEN_CASH_THRESHOLD = 'ADDED_DEPOSIT_LESS_THEN_CASH_THRESHOLD',
  PORTFOLIO_DECLINE = 'PORTFOLIO_DECLINE',
  PORTFOLIO_LIQUIDATED = 'PORTFOLIO_LIQUIDATED',
  TRADING_COMPLETED = 'TRADING_COMPLETED',
  WITHDRAWAL_EXECUTION = 'WITHDRAWAL_EXECUTION',
  WITHDRAWAL_REQUEST_ALL = 'WITHDRAWAL_REQUEST_ALL',
  WITHDRAWAL_REQUEST_PART = 'WITHDRAWAL_REQUEST_PART',
  BLOG_CONFIRMED = 'BLOG_CONFIRMED',
}

export interface IApiHeadersGetterInput {
  accept: 'application/json' | 'image/jpeg' | 'text/event-stream',
  isNativeApp: boolean,
  accessToken: string,
}
